export const cleanSearchQuery = (query: string) =>
  query?.trim().replace(/[-+()"']/gi, ' ')
